export default {
    home: {
        text_1: "온체인 거래의 새로운 정의",
        text_2: "거래 시작",
        text_3: "{x} 사용자가 참가했습니다",
    },
};
